// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: #ffffff;
  padding: 3.2rem 4rem 3.6rem;
  border-radius: 1.6rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.14);
  width: 100%;
  max-width: 52rem;
  text-align: center;
}

/* Variante avec icône : moins de padding haut car l'icône fait office d'espace */
.modal-content--with-icon {
  padding-top: 2.8rem;
}

.modal-icon {
  display: flex;
  justify-content: center;
  margin-bottom: 1.6rem;
}

.modal-content h2 {
  font-size: 2rem;
  color: #111827;
  margin-bottom: 1.2rem;
  font-weight: 700;
  line-height: 1.3;
}

.modal-text {
  margin-bottom: 2.8rem;
  font-size: 1.5rem;
  color: #4b5563;
  line-height: 1.7;
  text-align: center;
}

/* Séparateur visuel avant les boutons */
.modal-actions {
  display: flex;
  justify-content: center;
  gap: 1.2rem;
  padding-top: 2rem;
  border-top: 1px solid #f3f4f6;
}

/* Circular progress sur le bouton de confirmation pendant le chargement */
.vp-spinner {
  display: inline-block;
  width: 1.6rem;
  height: 1.6rem;
  border: 2px solid rgba(255, 255, 255, 0.45);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: vp-spin 0.7s linear infinite;
  vertical-align: middle;
}

@keyframes vp-spin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/composants/ValidationPopUp/ValidationPopUp.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;EACrB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,iFAAiF;AACjF;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,0EAA0E;AAC1E;EACE,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,2CAA2C;EAC3C,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.modal-content {\r\n  background-color: #ffffff;\r\n  padding: 3.2rem 4rem 3.6rem;\r\n  border-radius: 1.6rem;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.14);\r\n  width: 100%;\r\n  max-width: 52rem;\r\n  text-align: center;\r\n}\r\n\r\n/* Variante avec icône : moins de padding haut car l'icône fait office d'espace */\r\n.modal-content--with-icon {\r\n  padding-top: 2.8rem;\r\n}\r\n\r\n.modal-icon {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-bottom: 1.6rem;\r\n}\r\n\r\n.modal-content h2 {\r\n  font-size: 2rem;\r\n  color: #111827;\r\n  margin-bottom: 1.2rem;\r\n  font-weight: 700;\r\n  line-height: 1.3;\r\n}\r\n\r\n.modal-text {\r\n  margin-bottom: 2.8rem;\r\n  font-size: 1.5rem;\r\n  color: #4b5563;\r\n  line-height: 1.7;\r\n  text-align: center;\r\n}\r\n\r\n/* Séparateur visuel avant les boutons */\r\n.modal-actions {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 1.2rem;\r\n  padding-top: 2rem;\r\n  border-top: 1px solid #f3f4f6;\r\n}\r\n\r\n/* Circular progress sur le bouton de confirmation pendant le chargement */\r\n.vp-spinner {\r\n  display: inline-block;\r\n  width: 1.6rem;\r\n  height: 1.6rem;\r\n  border: 2px solid rgba(255, 255, 255, 0.45);\r\n  border-top-color: #ffffff;\r\n  border-radius: 50%;\r\n  animation: vp-spin 0.7s linear infinite;\r\n  vertical-align: middle;\r\n}\r\n\r\n@keyframes vp-spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
